import React from "react";
import {Grid} from "@material-ui/core";
import {BtnBlueFilled, Ripple} from "../../../../../Buttons";

import Input from '../Input';
import DeleteBtn from '../DeleteBtn';

export default ({
  clickOnUpload,

  uploadFile,
  reUploadFile,
  deleteFile,

  id,
  value = [],
  loading,
  disabled
}) => {
  const inputId = `${id}Input`;

  return (
    <Grid container spacing={4}>
      <Grid item sm={6} xs={12}>
        <BtnBlueFilled
          onClick={clickOnUpload(inputId)}
          disabled={disabled}
          loading={loading}
          heightMedium
        >
          Upload +
        </BtnBlueFilled>
        <Input
          id={inputId}
          onChange={uploadFile}
          disabled={disabled || loading}

          multiple
        />
      </Grid>
      {value.map((el, i) => {
        return (
          <Grid item key={i} sm={6} xs={12}>
            <div className="merchant-upload__item-btn multiple">
              <Ripple
                onClick={clickOnUpload(`${inputId}-${i}`)}
                disabled={disabled}
                loading={loading}
                heightMedium
              >
                <span className="merchant-upload__item-name">
                  {el.name}
                </span>
                <DeleteBtn onClick={deleteFile(el.id)} />
              </Ripple>
              <Input
                id={`${inputId}-${i}`}
                onChange={reUploadFile(i)}
                disabled={disabled || loading}
              />
            </div>
          </Grid>
        )
      })}
    </Grid>
  )
}
